import {
  GET_STATUSES,
  GET_STATUSES_INVOKED,
  GET_STATUSES_SUCCESS,
} from "src/redux/actions/travelerTracker";
import { TravelSegment } from "src/types/TravelSegments";

export type TravelerTrackerStatus = {
  code: string;
  count: number;
  id: string;
  isCalculated?: boolean;
  isSelected: boolean;
  segments: TravelSegment[];
  text: string;
};

export interface TravelerTrackerI {
  loading: boolean;
  statuses?: TravelerTrackerStatus[];
  error?: Error;
}

export interface TravelerTrackerState {
  ids: {
    [key: string]: TravelerTrackerI;
  };
}

export const initialState: TravelerTrackerState = { ids: {} };

type TravelerTrackerGetStatusesInvokedI = {
  type: typeof GET_STATUSES_INVOKED | typeof GET_STATUSES;
  id: string;
};

type TravelerTrackerGetStatusesSuccessI = {
  type: typeof GET_STATUSES_SUCCESS;
  id: string;
  statuses: TravelerTrackerStatus[];
};

export type TravlerTrackerAction =
  | TravelerTrackerGetStatusesInvokedI
  | TravelerTrackerGetStatusesSuccessI;

const travelerTracker = (
  state = initialState,
  action: TravlerTrackerAction,
) => {
  switch (action.type) {
    case GET_STATUSES_INVOKED:
      return {
        ...state,
        ids: {
          ...state.ids,
          [action.id]: {
            loading: true,
          },
        },
      };
    case GET_STATUSES_SUCCESS:
      return {
        ...state,
        ids: {
          ...state.ids,
          [action.id]: {
            loading: false,
            statuses: action.statuses,
          },
        },
      };
    default:
      return state;
  }
};

export default travelerTracker;
